import {Controller} from '@hotwired/stimulus';

/**
 * Recopie la saisie d'un champ dans ses champs miroirs, typiquement les champs masqués qui portent
 * la même valeur pour chaque langue.
 *
 *   <form {{ stimulus_controller('field-mirror') }}>
 *     {{ form_row_v(form.versions, 'space_id', {attr: stimulus_target('field-mirror', 'mirror').toArray()}) }}
 *     <input type="text" {{ stimulus_action('field-mirror', 'copy', 'input') }}>
 *   </form>
 */
export default class extends Controller {
  static targets = ['mirror'];

  copy(event) {
    const {value} = event.currentTarget;

    for (const mirror of this.mirrorTargets) {
      mirror.value = value;
    }
  }
}
